import React from "react";
import styled from "styled-components";

import Navbar from "../SubComponents/Navbar";
import Slides from "../SubComponents/Slides";
import img1 from "../assets/img1.png";
import Button from "../SubComponents/Button";

const Section = styled.section`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
`;

const BlackWrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1;
  background-color: rgba(32, 32, 32, 0.3);
`;

const ImageContainer = styled.div`
  width: 100%;
  height: calc(100vh - 6rem);

  img {
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  `;

const Heading = styled.div`
  width: 80%;
  position: absolute;
  top: 14rem;
  color: white;
  z-index: 0;
  /* border: 2px solid black; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  h2{
    font-size: 2rem;
  }
  h1{
    width: 100%;
    font-size: 4rem;
    /* border: 1px solid red; */
    text-align: center;
  }
`;

const About = styled.div`
  width: 100vw;
  min-height: 110vh;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  `;

const Text = styled.h1`
font-size: 4rem;
font-weight: 600;
z-index: 6;
`;

const Subtext = styled.h2`
width: 80%;
text-align: center;
z-index: 6;
`;

const Home = () => {
  return (
    <Section>
    <Navbar />
      <BlackWrapper />
      <ImageContainer>
        <img src={img1} alt="beach" />
      </ImageContainer>
      <Heading>
        <h2>look for events, hotels and beach clubs around you</h2>
        <h1>
        Its <i>all about</i> beach <br/>
        Love, sea and sun <br/>
        BBQ & Rhum
        </h1>
      </Heading>
      <About>
      <Text>Beachvent</Text>
      <Subtext>
          Away from the crowded, dusty city, with family and friends, come to experience Beach events and clubs. What is more wonderful when opening your eyes, the first thing you see is the high dear blue sky and calm ocean with gentle waves as far as the eye. The immensity of nature will help you receive positive energy and help you enjoy yourself in the most relaxing way. Feel the golden sunshine, white sand, blue sea to forget all fatigue.
        </Subtext>
        <Slides />
        <Button text="Explore Us ->" link="/explore" />
      </About>
    </Section>
  );
};

export default Home;
